import React, { useMemo } from "react";
import RichTextEditor from "./RichTextEditor";

const MentionEditor = ({
  users = [],
  onOutputChange,
  ...props
}) => {
  const mentionUsers = useMemo(
    () =>
      (Array.isArray(users) ? users : [])
        .filter((u) => u && (u.id || u.userId))
        .map((u) => ({
          id: String(u.id || u.userId),
          name:
            u.name ||
            `${u.firstName || ""} ${u.lastName || ""}`.trim() ||
            u.email ||
            String(u.id || u.userId),
          email: u.email || "",
        })),
    [users],
  );

  return (
    <RichTextEditor
      {...props}
      mentionUsers={mentionUsers}
      onOutputChange={onOutputChange}
    />
  );
};

export default MentionEditor;
